/* eslint-disable @typescript-eslint/no-explicit-any */
var ValidationLevel;
(function (ValidationLevel) {
    ValidationLevel["ERROR"] = "error";
    ValidationLevel["WARNING"] = "warning";
})(ValidationLevel || (ValidationLevel = {}));
var ValidationRules;
(function (ValidationRules) {
    ValidationRules["required"] = "required";
    ValidationRules["minLength"] = "minLength";
    ValidationRules["maxLength"] = "maxLength";
    ValidationRules["maxCharacters"] = "maxCharacters";
    ValidationRules["CodiceFiscaleAlfaNumerico"] = "CodiceFiscaleAlfaNumerico";
    ValidationRules["PartitaIva"] = "PartitaIva";
    ValidationRules["CodiceFiscale"] = "CodiceFiscale";
    ValidationRules["IBAN"] = "IBAN";
    ValidationRules["Fax"] = "Fax";
    ValidationRules["Email"] = "Email";
    ValidationRules["EmailStrict"] = "EmailStrict";
    ValidationRules["Range"] = "Range";
    ValidationRules["Pattern"] = "Pattern";
    ValidationRules["Telefono"] = "Telefono";
    ValidationRules["DateRange"] = "DateRange";
    ValidationRules["NumberRange"] = "NumberRange";
    ValidationRules["weekdays"] = "weekdays";
})(ValidationRules || (ValidationRules = {}));

export { ValidationLevel, ValidationRules };
